export const RoomActions = {
  NEW: 'new',
  UPDATE: 'update',
} as const;

export type RoomActionType = (typeof RoomActions)[keyof typeof RoomActions];

export type RoomUrlAfterSubmitType = {
  roomId: string;
  roomActionType: RoomActionType;
  isLTI?: boolean;
};

export const getRoomSegment = (isLTI: boolean | undefined): string => {
  return isLTI ? '/lti/rooms' : '/magic-student/rooms';
};

export const getRoomUrlAfterSubmit = ({ isLTI, roomId, roomActionType }: RoomUrlAfterSubmitType): string => {
  const roomSegment = getRoomSegment(isLTI);
  const baseUrl = `${roomSegment}/${roomId}`;
  const roomIdParam = `?roomId=${roomId}`;

  if (isLTI) {
    if (roomActionType === RoomActions.UPDATE) {
      // [ENG-2412] If the room is updated, we want the user to land back in the room
      return baseUrl;
    }

    // [ENG-2495] If a new room has been created/launched we want to drop the user back on the LTI rooms page, not in the room itself
    return `${roomSegment}${roomIdParam}`;
  }

  const hasJoinInfo = roomActionType === RoomActions.NEW;

  // If the roomActionType is "new", we want to bring the user to the room page and open the join info modal
  return hasJoinInfo ? `${baseUrl}?joinInfoModalOpen=true` : baseUrl;
};
